import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select, MenuItem, Input, withStyles } from 'material-ui';
import MenuItemStyles from './MenuItemStyles';

/**
 * ## Redux imports
 */
import * as relationshipTypesActions from '../../../redux/actions/RelationshipTypesActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../../redux/selectors/Index';

/**
 * ## Redux boilerplate
 */
const actions = [ relationshipTypesActions ];

function mapStateToProps (state) {
  let getRelationshipTypes = selectors.relationshipTypes.getRelationshipTypes;
  return {
    relationshipTypes: getRelationshipTypes(state.relationshipTypes),
    reservationId: selectors.general.getReservationId(state.general),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

class RelationshipDropdown extends Component {
  static propTypes = {
    actions: PropTypes.object,
    classes: PropTypes.object,
    relationshipTypes: PropTypes.arrayOf(PropTypes.object),
    relationshipType: PropTypes.string,
    selectRelationshipType: PropTypes.func,
    reservationId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  };

  constructor (props) {
    super(props);

    props.actions.getRelationshipTypes(props.reservationId);
  }

  render () {
    const { relationshipTypes, relationshipType, selectRelationshipType, classes } = this.props;

    return (
      <Select
        value={relationshipType}
        onChange={selectRelationshipType}
        input={<Input id='select-multiple' />}
      >
        {relationshipTypes.map(type => (
          <MenuItem
            key={type.value}
            value={type.value}
            selected={type.value === relationshipType}
            classes={classes}
          >
            {type.text}
          </MenuItem>
        ))}
      </Select>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(MenuItemStyles)(RelationshipDropdown)
);



// WEBPACK FOOTER //
// ./src/components/passengers/relationshipDropdown/RelationshipDropdown.js